// src/Public/landing-data.js

import { ASSETS } from './assets-data';

// Uploaded feature icons (media registry) → info-card bubbles.
const INFO_CARD_ITEMS = [
    { img: ASSETS.WIND_WEATHER_ICON_CIRCLE,      imgFit: 'contain', label: 'Storm & Wind\nProtection', desc: 'Shield windows and openings from hurricane force winds and driving rain.' },
    { img: ASSETS.SUN_ICON_NAVY_CIRCLE,          imgFit: 'contain', label: 'Sun & UV\nControl',        desc: 'Cut glare and block harmful UV while keeping interiors cool.' },
    { img: ASSETS.BUG_INSECT_ICON_NAVY_CIRCLE,   imgFit: 'contain', label: 'Insect\nProtection',       desc: 'Enjoy the outdoors bug free with fine mesh retractable screens.' },
    { img: ASSETS.ROLLING_SHUTTER_DOOR_ICON,     imgFit: 'contain', label: 'Roll-Down\nShutters',      desc: 'Durable roll down shutters for security, storm and privacy.' },
    { img: ASSETS.PRESENTATION_SCREEN_ICON_NAVY, imgFit: 'contain', label: 'Retractable\nScreens',     desc: 'Motorized screens that disappear when you don’t need them.' },
    { img: ASSETS.SOLAR_PANEL_COLLECTOR_ICON,    imgFit: 'contain', label: 'Energy\nEfficiency',       desc: 'Reduce cooling costs and improve your home’s efficiency.' },
    { img: ASSETS.ADJUSTABLE_HEIGHT_TABLE_ICON,  imgFit: 'contain', label: 'Motorized\nControl',       desc: 'One touch and remote control for effortless everyday use.' },
];

// Uploaded process/install photos → the "Our Process" steps.
const PROCESS_STEPS = [
    { title: 'Free Consultation & Measure', desc: 'We visit, assess your space, and take precise measurements for a perfect fit.', image: ASSETS.WINDOW_FRAME_WIDTH_MEASUREMENT_TAPE },
    { title: 'Choose Your Screens & Fabric', desc: 'Pick the right screen type, fabric, and finish from our full range of options.', image: ASSETS.MAESTROSHIELD_RETRACTABLE_SCREEN_FABRIC_SAMPLES },
    { title: 'Professional Installation', desc: 'Our team installs everything cleanly and securely, tested and ready to use.', image: ASSETS.MAKITA_DRILL_WINDOW_FRAME_METAL_INSTALLATION },
    { title: 'Enjoy Your Space', desc: 'Relax in a cooler, bug free, weather protected outdoor living space.', image: ASSETS.SUNSET_OCEAN_VIEW_COVERED_PATIO_SECTIONAL_SOFA },
];

const PROCESS_SUBTITLE = 'From consultation to everyday comfort, a simple, seamless experience.';
const PROCESS_EYEBROWS = [];

// Reviewer avatars (uploaded Google-review photos) reused for the hero social-proof
// row and the review cards. Shown as small overlapping circles in the hero.
const REVIEW_AVATARS = [
    ASSETS.MAESTRO_SHEILD_REVIEW_1,
    ASSETS.MAESTRO_SHEILD_REVIEW_2,
    ASSETS.MAESTRO_SHEILD_REVIEW_3,
    ASSETS.MAESTRO_SHEILD_REVIEW_4,
    ASSETS.MAESTRO_SHEILD_REVIEW_5,
];
const HERO_SOCIAL_PROOF = {
    avatars: REVIEW_AVATARS,
    rating: 5,
    text: 'Trusted by homeowners and businesses nationwide',
};

const LandingData = {
    he: {
        seo: {
            title: '{business} | Section Title',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image: '/placeholder.svg'
        },

        // NOTE: Hebrew copy is English for now, matches system_data_he (pending translation).
        heroSection: {
            eyebrow: 'Section Title',
            // {location} is filled at runtime from businessInfo (provisioned per
            // client); the "in {location}" line is dropped when no location is set.
            heroTitleLines: [
                { text: 'Retractable Screens Installation', accent: false },
                { text: 'in {location}', accent: true },
            ],
            heroSubtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            primaryCtaText: 'Get Started',
            // Phone is pulled from businessInfo at runtime; this is the fallback.
            phone: '(000) 000-0000',
            // The standing inspector cutout (transparent PNG) that straddles the diagonal split.
            heroPerson: '/placeholder.svg',
            // Trust chips shown under the paragraph.
            features: [],
            watchCtaText: 'OUR SERVICES',
            videoUrl: '',
            primaryTarget: { id: 'contact', href: '/#contact' },
            watchTarget: { id: 'services', href: '/#services' },
            heroImages: [],
            // Overlapping reviewer avatars + star rating shown under the CTAs.
            socialProof: HERO_SOCIAL_PROOF,
        },

        trustSection: {
            label: 'Section Title',
            headingLine1: 'Headline goes here',
            headingLine2: 'Headline goes here',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            slideCtaText: 'Learn More',
            points: [
                {
                    title: 'Item One',
                    href: '/services/item-one',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Two',
                    href: '/services/item-two',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Three',
                    href: '/services/item-three',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Four',
                    href: '/services/item-four',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
            ],
            ctaText: 'See All Services',
            ctaHref: '/services',
        },

        infoCardsSection: {
            titleLine1: 'Headline goes here',
            titleLine2: 'Headline goes here',
            paragraph: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            cta: { text: 'See How We Can Help', href: '#contact' },
            items: INFO_CARD_ITEMS,
        },
        processSection: {
            title: 'Our Process',
            subtitle: PROCESS_SUBTITLE,
            eyebrows: PROCESS_EYEBROWS,
            steps: PROCESS_STEPS,
        },

        reviewsSection: {
            title: 'What Our Customers Say',
            subtitle: 'Real reviews from homeowners who trusted us with their space.',
        },

        gallerySection: {
            title: 'Section Title',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            buttonText: 'Learn More ←',
            backText: 'Back',
        },

        contentSection: {
            label: 'Section Title',
            title: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            backgroundImage: '/placeholder.svg',
            buttonText: 'Learn More →',
        },

        metricsSection: {
            metrics: [
                { value: 100, suffix: '%', label: 'Metric One', duration: 3 },
                { value: 24, suffix: '/7', label: 'Metric Two', duration: 3.2 },
                { value: 40, suffix: '%', label: 'Metric Three', duration: 3.5 },
                { value: 1, suffix: 'T', label: 'Metric Four', duration: 2.8 },
            ],
            disclaimer: '* Add your content here. This placeholder describes the section and can be replaced with your own copy.'
        },

        specialsBannerSection: {
            title: 'Headline goes here',
            highlight: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            ctaText: 'Get Started',
            images: [
                '/placeholder.svg',
                '/placeholder.svg',
            ],
            mobileImages: [
                '/placeholder.svg',
                '/placeholder.svg',
            ]
        },

        shopHeroSection: {
            image: '/placeholder.svg',
            titleLine1: 'Headline goes here',
            titleHighlight: 'Headline goes here',
            titleLine2: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            ctaText: 'Get Started',
            trustText: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            categoryShopPrefix: 'Services'
        },

        categoriesBentoSection: {
            title: 'Section Title',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            maxCategories: 4,
        },

        imageGridSection: {
            items: [
                {
                    image: '/placeholder.svg',
                    title: 'Item One',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-primary-900',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-60 group-hover:opacity-100 transition-opacity',
                    link: '/services/item-one'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Two',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-secondary-700',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-70 group-hover:scale-110 transition-transform duration-700',
                    link: '/services/item-two'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Three',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-primary-500',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-80',
                    link: '/services/item-three'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Four',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-slate-100',
                    textColor: 'text-primary-950',
                    imgPositionClass: 'inset-0 object-cover opacity-40 mix-blend-multiply',
                    link: '/services/item-four'
                }
            ]
        }
    },

    en: {
        seo: {
            title: '{business} | Section Title',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image: '/placeholder.svg'
        },

        heroSection: {
            eyebrow: 'Section Title',
            // {location} is filled at runtime from businessInfo (provisioned per
            // client); the "in {location}" line is dropped when no location is set.
            heroTitleLines: [
                { text: 'Retractable Screens Installation', accent: false },
                { text: 'in {location}', accent: true },
            ],
            heroSubtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            primaryCtaText: 'Get Started',
            phone: '(000) 000-0000',
            heroPerson: '/placeholder.svg',
            features: [],
            watchCtaText: 'OUR SERVICES',
            videoUrl: '',
            primaryTarget: { id: 'contact', href: '/#contact' },
            watchTarget: { id: 'services', href: '/#services' },
            heroImages: [],
            // Overlapping reviewer avatars + star rating shown under the CTAs.
            socialProof: HERO_SOCIAL_PROOF,
        },

        trustSection: {
            label: 'Section Title',
            headingLine1: 'Headline goes here',
            headingLine2: 'Headline goes here',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            slideCtaText: 'Learn More',
            points: [
                {
                    title: 'Item One',
                    href: '/services/item-one',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Two',
                    href: '/services/item-two',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Three',
                    href: '/services/item-three',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
                {
                    title: 'Item Four',
                    href: '/services/item-four',
                    image: '/placeholder.svg', // add an image URL/S3 path here; falls back to placeholder
                    items: ['Feature one', 'Feature two', 'Feature three'],
                },
            ],
            ctaText: 'See All Services',
            ctaHref: '/services',
        },

        infoCardsSection: {
            titleLine1: 'Headline goes here',
            titleLine2: 'Headline goes here',
            paragraph: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            cta: { text: 'See How We Can Help', href: '#contact' },
            items: INFO_CARD_ITEMS,
        },

        processSection: {
            title: 'Our Process',
            subtitle: PROCESS_SUBTITLE,
            eyebrows: PROCESS_EYEBROWS,
            steps: PROCESS_STEPS,
        },

        reviewsSection: {
            title: 'What Our Customers Say',
            subtitle: 'Real reviews from homeowners who trusted us with their space.',
        },

        gallerySection: {
            title: 'Section Title',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            buttonText: 'Learn More →',
            backText: 'Back',
        },

        contentSection: {
            label: 'Section Title',
            title: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            backgroundImage: '/placeholder.svg',
            buttonText: 'Learn More →',
        },

        metricsSection: {
            metrics: [
                { value: 100, suffix: '%', label: 'Metric One', duration: 3 },
                { value: 24, suffix: '/7', label: 'Metric Two', duration: 3.2 },
                { value: 40, suffix: '%', label: 'Metric Three', duration: 3.5 },
                { value: 1, suffix: 'T', label: 'Metric Four', duration: 2.8 },
            ],
            disclaimer: '* Add your content here. This placeholder describes the section and can be replaced with your own copy.'
        },

        specialsBannerSection: {
            title: 'Headline goes here',
            highlight: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            ctaText: 'Get Started',
            images: ['/placeholder.svg', '/placeholder.svg'],
            mobileImages: ['/placeholder.svg', '/placeholder.svg']
        },

        shopHeroSection: {
            image: '/placeholder.svg',
            titleLine1: 'Headline goes here',
            titleHighlight: 'Headline goes here',
            titleLine2: 'Headline goes here',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            ctaText: 'Get Started',
            trustText: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            categoryShopPrefix: 'SERVICES'
        },

        categoriesBentoSection: {
            title: 'Section Title',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            maxCategories: 4,
        },

        imageGridSection: {
            items: [
                {
                    image: '/placeholder.svg',
                    title: 'Item One',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-primary-900',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-60 group-hover:opacity-100 transition-opacity',
                    link: '/services/item-one'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Two',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-secondary-700',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-70 group-hover:scale-110 transition-transform duration-700',
                    link: '/services/item-two'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Three',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-primary-500',
                    textColor: 'text-white',
                    imgPositionClass: 'inset-0 object-cover opacity-80',
                    link: '/services/item-three'
                },
                {
                    image: '/placeholder.svg',
                    title: 'Item Four',
                    description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
                    bgColor: 'bg-slate-100',
                    textColor: 'text-primary-950',
                    imgPositionClass: 'inset-0 object-cover opacity-40 mix-blend-multiply',
                    link: '/services/item-four'
                }
            ]
        }
    }
};

export function getLandingData(language) {
    return LandingData[language] || LandingData.en;
}

export default LandingData;
